export default __webpack_public_path__ + "images/48093b3d0074e8aea39d916ddd63ae5b.png";